<template>
  <div class="learning-profile">
    <answer-collect v-if="editing" :cid="cid" :query="query" :extraObj="fields"
      :initialValue="profile" :submitting="submitting" @saveuserinfo="submit" />
    <div v-else class="profile-confirmation" role="dialog" aria-modal="true" aria-labelledby="profile-confirmation-title">
      <h2 id="profile-confirmation-title">身份确认</h2>
      <dl>
        <template v-for="key in Object.keys(fields)">
          <dt :key="key + '-label'">{{ label(key) }}</dt>
          <dd :key="key + '-value'">{{ profile[key] }}</dd>
        </template>
      </dl>
      <div class="profile-actions">
        <button type="button" class="primary" :disabled="submitting" @click="submit(profile)">确认</button>
        <button type="button" :disabled="submitting" @click="edit">修改</button>
      </div>
    </div>
  </div>
</template>

<script>
import AnswerCollect from './answer-collect';
import { learningProfileFields, copyLearningProfile, hasLearningProfile } from '@/utils/learning-assessment-profile';

export default {
  components: { AnswerCollect },
  props: ['cid', 'query', 'extraObj', 'initialValue', 'submitting'],
  data() { return { profile: {}, editing: false }; },
  computed: {
    fields() { return learningProfileFields(this.extraObj); }
  },
  created() {
    this.profile = copyLearningProfile(this.fields, this.initialValue);
    this.editing = !hasLearningProfile(this.fields, this.profile);
    document.title = this.editing ? '个人信息提交' : '身份确认';
  },
  methods: {
    label(key) {
      return { _identity2: '身份', _identity3: '年级' }[key] || this.fields[key];
    },
    edit() {
      this.editing = true;
      document.title = '个人信息提交';
    },
    submit(profile) {
      if (this.submitting) return;
      this.profile = copyLearningProfile(this.fields, profile);
      this.$emit('saveuserinfo', { ...this.profile });
    }
  }
};
</script>

<style lang="scss" scoped>
.learning-profile {
  position: fixed;
  inset: 0;
  z-index: 2000;
  overflow-y: auto;
  background: #f5f5f5;
}
.profile-confirmation {
  margin: 80px 30px;
  padding: 40px 30px;
  border-radius: 16px;
  background: #fff;
  h2 { margin: 0 0 32px; color: #333; font-size: 36px; text-align: center; }
  dl { display: grid; grid-template-columns: 160px 1fr; gap: 24px 16px; margin: 0; font-size: 28px; line-height: 1.5; }
  dt { color: #666; }
  dd { margin: 0; color: #333; overflow-wrap: anywhere; }
}
.profile-actions {
  display: flex;
  gap: 24px;
  margin-top: 48px;
  button { flex: 1; padding: 22px 0; border: 1px solid #eb5032; border-radius: 48px; background: #fff; color: #eb5032; font-size: 30px; }
  .primary { background: #eb5032; color: #fff; }
  button:disabled { opacity: .5; }
}
</style>
